module.exports = {
  PREVIEW_PATH: '/preview/:build_identifier'
}


// WEBPACK FOOTER //
// ./lib/brave-build/constants.js